import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchTotalPoolBreakdownReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getTotalPoolBreakdownReport',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
    queryStringParams: {
      endDate: moment(payload.params.endDate).format('YYYY-MM-DD'),
      startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchTotalPoolBreakdownReport;
